import React from 'react'

const SausersMain = () => {
  return (
    <div>Users</div>
  )
}

export default SausersMain